import { useCallback, useState } from "react";
import dayjs from "dayjs";
import CreateAppointmentsModal from "./CreateAppointmentsModal";
import { useAppointments } from "../../../hooks/useAppointments";
import { Calendar, momentLocalizer } from "react-big-calendar";
//@ts-ignore
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
const localizer = momentLocalizer(moment);

const CustomCalendar = () => {
  const [monthYear, setMonthYear] = useState(dayjs().format("MM-YYYY"));
  const [editingAppointment, setEditingAppointment] = useState(null);

  const { formattedAppointments, grouped } = useAppointments(monthYear);

  const onRangeChange = useCallback(
    (range) => {
      const fmt = (date) => dayjs(date).format("MM-YYYY");
      const isMonthView = range?.start;

      let newMonth;

      if (isMonthView) {
        const middleDate = dayjs(range.start)
          .add(dayjs(range.end).diff(dayjs(range.start), "day") / 2, "day")
          .format("MM-YYYY");
        newMonth = middleDate;
      } else {
        const start = fmt(range[0]);
        const end = range.length > 1 && fmt(range[range.length - 1]);
        newMonth = start !== monthYear ? start : end;
      }
      if (newMonth && newMonth !== monthYear) {
        setMonthYear(newMonth);
      }
    },
    [monthYear],
  );

  return (
    <>
      <div className="calendar-div">
        <Calendar
          localizer={localizer}
          events={formattedAppointments}
          defaultView="week"
          views={["month", "week", "day"]}
          startAccessor="start_time"
          endAccessor="end_time"
          selectable
          onSelectSlot={(ee) =>
            setEditingAppointment({
              start_time: ee?.start,
              end_time: ee?.end,
            })
          }
          onRangeChange={onRangeChange}
          onSelectEvent={(event) => setEditingAppointment(event)}
          scrollToTime={new Date(0, 0, 0, 8, 0, 0)}
        />
      </div>

      {editingAppointment && (
        <CreateAppointmentsModal
          editingAppointment={editingAppointment}
          setEditingAppointment={setEditingAppointment}
          groupedAppointments={grouped}
        />
      )}
    </>
  );
};

export default CustomCalendar;
